import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/auth/login/LoginForm.tsx");
